import script from "./ContextMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContextMenu.vue?vue&type=script&lang=ts&setup=true"

import "./ContextMenu.vue?vue&type=style&index=0&id=b70d7962&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b70d7962"]])

export default __exports__